import { Button, Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import ActivityTable from "./ActivityTable";
import ActivityFilter from "../components/ActivityFilter";
import theme from "../../configs/theme";
import ActivityCreate from "./ActivityCreate";
import ActivityEdit from "./ActivityEdit";
import ActivityDelete from "./ActivityDelete"
import Balance from "./Balance";
import { getUser } from "../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function Actividad() {
  const [empresa, setEmpresa] = useState(null);
  const [filters, setFilters] = useState({
    search: "",
    operation: "",
    priceRange: [0, 10000000],
    dateFilter: "",
  })
  const [visibleActivities, setVisibleActivities] = useState([]);
  const [selectedAction, setSelectedAction] = useState(null);
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const [selectedActivities, setSelectedActivities] = useState([]);

  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        const user = getUser();
        const response = await fetch(`${URL}/api/empresas/${user.empresa_id}`);
        if (response.ok) {
          const data = await response.json();
          setEmpresa(data);
        } else {
          console.error("Error al obtener la empresa");
        }
      } catch (error) {
        console.error("Error de red al obtener la empresa", error);
      }
    };

    fetchEmpresa();
  }, []);

  const handleAction = (action) => {
    console.log("Se selecciono:", selectedAction);
    setSelectedAction((prev) => {
      if (prev === action) {
        if (action === "create") {
          setIsCreateMode(false);
        } else if (action === "update") {
          setIsUpdateMode(false);
        } else if (action === "delete") {
          setIsDeleteMode(false);
        }
        return null;
      }
  
      if (action === "create") {
        setIsCreateMode(true);
        setIsDeleteMode(false);
        setIsUpdateMode(false);
      } else if (action === "update") {
        setIsCreateMode(false);
        setIsUpdateMode(true);
        setIsDeleteMode(false);
      } else if (action === "delete") {
        setIsCreateMode(false);
        setIsDeleteMode(true);
        setIsUpdateMode(false);
      }
  
      return action;
    });
  };

  return (
    <Box
      sx={{
        mt: 1,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >

      <Box
        sx={{ display: "flex", flexDirection: "row", mt: 1 }}
      >
        {/* Filtros de busqueda */}
        <Box
          sx={{
            width: "58%",
            height: "10%",
            mb: 0,
          }}
        >
          <ActivityFilter onFilterChange={setFilters}/>
        </Box>

        {/* Caja de Balance mensual */}
        <Box
          sx={{
            width: "39%",
            height: "10%",

            ml: 4
          }}
        >
          <Balance />
        </Box>
      </Box>

      {/* Tabla de actividades y modificadores */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "82%",
          mt: 2,
        }}
      >
        <ActivityTable 
          filters={filters}
          showCheckbox={isUpdateMode || isDeleteMode}
          checkboxLabel={isUpdateMode ? "Update" : "Borrar"}
          selectedActivities={selectedActivities}
          setSelectedActivities={setSelectedActivities} 
          setVisibleActivities={setVisibleActivities}
        />
        <Box
          sx={{
            ml: 2,
            width: "36%",
            bgcolor: theme.tableColors.body,
            borderRadius: "8px",
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Botones */}
          <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
            <Button 
              variant={isCreateMode ? "contained" : "outlined"} 
              fullWidth 
              color="success" 
              onClick={() => handleAction("create")}
            >
              Crear
            </Button>
            <Button 
              variant={isUpdateMode ? "contained" : "outlined"} 
              fullWidth
              onClick={() => handleAction("update")}
            >
              Editar
            </Button>
            <Button 
              variant={isDeleteMode ? "contained" : "outlined"} 
              fullWidth 
              color="error"
              onClick={() => handleAction("delete")}
            >
              Borrar
            </Button>
          </Box>

          {isCreateMode && (
            <ActivityCreate
              empresaNombre={empresa.nombre}
              empresa={empresa}
              onClose={() => setIsCreateMode(false)}
              onSuccess={() => setSelectedAction(null)}
            />
          )}

          {isUpdateMode && (
            <ActivityEdit
              empresaNombre={empresa.nombre}
              empresa={empresa}
              selectedActivity={visibleActivities.find(act => act.id === selectedActivities[0])}
              onUpdate={() => setSelectedAction(null)}
              onClose={() => {
                setIsUpdateMode(false);
                setSelectedActivities([]);
              }}
            /> 
          )}

          {isDeleteMode && (
            <ActivityDelete
              selectedActivities={selectedActivities}
              onDelete={() => {
                setSelectedActivities([]);
                setIsDeleteMode(false);
                setSelectedAction(null);
              }}
            /> 
          )}

        </Box>
      </Box>
    </Box>
  );
}